import React, { useState } from 'react';

import ActivityEditMobileActions from '../ActivityEditMobileAction';
import CollapsableItem from '../../utils/CollapsableItem';
import ActivitySourceOptions from '../ActivityMetaFields/ActivitySourceOptions';
import {
  ActivitySource,
  ActivitySourceValue,
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  StripeSourceMetadata,
  ExternalSourceMetadata,
} from '../../../types/Activity';
import { StripeAccount } from '../../../types/Stripe';

import ConnectStripeAccountFormMobile from './ConnectStripeAccountFormMobile';
import { isConnectedStripeAccount } from './helpers';

type Props = {
  commission: number;
  disabled: boolean;
  metadata: ExternalSourceMetadata | StripeSourceMetadata | undefined;
  onChange(prop: string, value: any): void;
  onSaveClick(value: any): void;
  showErrors: boolean;
  source: ActivitySource | undefined;
  stripeAccounts: StripeAccount[];
};

const ActivitySourceFieldsMobile = ({
  commission,
  disabled,
  metadata,
  onChange,
  onSaveClick,
  showErrors,
  source,
  stripeAccounts,
}: Props) => {
  const [isEditMode, setIsEditMode] = useState(false);

  return (
    <div className='data-box'>
      <h4 className='header' style={{ display: 'flex', alignItems: 'center' }}>
        Source
        {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          <ActivityEditMobileActions
            isEditMode={isEditMode}
            setIsEditMode={setIsEditMode}
            onSaveClick={onSaveClick}
            disabled={disabled}
          />
        }
      </h4>
      <CollapsableItem>
        <ActivitySourceOptions
          label='Source'
          initialValue={source}
          onMetaFieldsChange={value => onChange('source', value)}
          display='block'
        />
        {isConnectedStripeAccount(source) && (
          <ConnectStripeAccountFormMobile
            stripeAccounts={stripeAccounts}
            isEditMode={isEditMode}
            initialCommission={commission}
            metadata={metadata as StripeSourceMetadata}
            onChange={onChange}
            showErrors={showErrors}
            source={source as ActivitySourceValue}
          />
        )}
      </CollapsableItem>
    </div>
  );
};

export default ActivitySourceFieldsMobile;
